<div class="d-flex time-line-container" [ngClass]="this.alignItems === 'alternate' ? 'alternate' : ''" >
  <div class="img-container">
    <div class="line-container img-border"></div>
    <img [src]="imgPath" class="img"/>
  </div>
  <div *ngFor="let event of events; let i=index" class="time-line-item-container">
    <div class="line-container" [ngClass]="getContainerClass(i,event)">
      <div *ngIf="alignItems === 'bottom' || (alignItems === 'alternate' && i % 2 === 0); then thenBlockT else elseBlockT"></div>
      <ng-template #thenBlockT>
        <div class="date-container">
          <div style="height: 63px;"></div>
          <div class="event-description" [style]="{color: fontColor}">{{event.description}}</div>
          <div class="event-date" [style]="{color: fontColor}">{{getDateFormat(event.date)}}</div>
          <div class="red-dot"></div>
        </div>
      </ng-template>
      <ng-template #elseBlockT>
        <div class="event-name d-flex align-items-end">
          <span [style]="{color: fontColor}" ngbTooltip="event.name">
            {{event.name}}
          </span>
        </div>
      </ng-template>

      <div class="dotted-line"></div>

      <div *ngIf="alignItems === 'bottom' || (alignItems === 'alternate' && i % 2 === 0); then thenBlockB else elseBlockB">
      </div>
      <ng-template #thenBlockB>
        <div class="event-name">
          <span [style]="{color: fontColor}" ngbTooltip="event.name">
            {{event.name}}
          </span>
        </div>
      </ng-template>
      <ng-template #elseBlockB>
        <div class="date-container">
          <div class="red-dot"></div>
          <div class="event-date" [style]="{color: fontColor}">{{getDateFormat(event.date)}}</div>
          <div class="event-description" [style]="{color: fontColor}">{{event.description}}</div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="arrow"></div>
</div>
